import { Link } from "react-router-dom";
import Slider from "react-slick";
import {
  NextArrow,
  PrevArrow,
} from "../../components/SlickButtons/SlickButtons";
import "./Featured.css";
import CardSkeleton from "../../components/Skeleton/CardSkeleton";
import useDevice from "../../hooks/useDevice";
import { useGetFeatured } from "../../hooks/useGetFeatured";

function Featured() {
  const { isMobile, isTablet } = useDevice();

  const { data: monthlyFeatured, isLoading } = useGetFeatured();

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: isMobile ? 2 : isTablet ? 4 : 8,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <section className="Featured">
      <div className="section-title">
        <h3>Monthly Featured</h3>
      </div>
      <Slider {...sliderSettings}>
        {isLoading
          ? Array.from({ length: 8 }).map((_, index) => (
              <CardSkeleton
                key={index}
                width={"95%"}
                height={isTablet ? "312px" : "230px"}
              />
            ))
          : monthlyFeatured?.map(({ slug, name, images }) => (
              <Link
                to={`product/${slug.toLowerCase()}`}
                className={`product ${slug}`}
                key={slug}
              >
                <img src={images[0]?.src} alt={name} />
                <p className="product-card-name">{name}</p>
              </Link>
            ))}
      </Slider>
    </section>
  );
}

export default Featured;
